import React from 'react';
import cn from 'classnames';
import { useRecoilState, useRecoilValue } from 'recoil';
import { InteriorSwatch } from '~/common/components';
import { InteriorOption } from '~/common/models';
import {
  ActiveCarouselImageAssetState,
  VariantPageInteriorOptionsSelector,
  SelectedInteriorState,
} from '../../store';
import styles from './index.module.scss';

interface InteriorOptionsProps {
  className?: string;
}

export const InteriorOptions = React.memo<InteriorOptionsProps>(
  ({ className }) => {
    const [activeImageAsset] = useRecoilState(ActiveCarouselImageAssetState);
    const interiorOptions = useRecoilValue(VariantPageInteriorOptionsSelector);
    const [selectedInterior, setSelectedInterior] = useRecoilState(
      SelectedInteriorState
    );
    const [activeInterior, setActiveInterior] = React.useState<
      InteriorOption | undefined
    >(undefined);

    React.useEffect(() => {
      if (interiorOptions.length > 0) {
        setActiveInterior(interiorOptions[0]);
        setSelectedInterior(interiorOptions[0]);
      }
    }, []);

    React.useEffect(() => {
      if (!!selectedInterior) {
        setActiveInterior(selectedInterior);
      }
    }, [selectedInterior]);

    React.useEffect(() => {
      if (!!activeImageAsset && activeImageAsset.assetType === 'Interior') {
        setActiveInterior(
          interiorOptions.find(
            (x) => x.interiorOptionId === activeImageAsset.assetId
          )
        );
      }
    }, [activeImageAsset]);

    const handleSelect = (interior?: InteriorOption) => {
      if (!!interior) {
        setActiveInterior(interior);

        setSelectedInterior({ ...interior, interiorOptionId: '0' });
        setTimeout(() => {
          setSelectedInterior(interior);
        }, 100);
      }
    };

    return (
      <div className={cn(className, styles.interiorOptionContainer)}>
        <div className={styles.displayText}>
          <p className={styles.title}>Interior</p>
        </div>

        <div className={styles.interiorList}>
          {interiorOptions.map((interior, index) => (
            <InteriorSwatch
              key={index}
              interior={interior}
              onClick={() => handleSelect(interior)}
              isActive={
                activeInterior?.interiorOptionId === interior.interiorOptionId
              }
            />
          ))}

          {activeInterior && (
            <p className={styles.interiorName}>{activeInterior.description}</p>
          )}
        </div>
      </div>
    );
  }
);
